export const logs = (state) => {
  return state.logs;
};
export const isLogsLoading = (state) => {
  return state.isLogsLoading;
};
export const isLogsError = (state) => {
  return state.isLogsError;
};
